export default __webpack_public_path__ + "static/media/bike_image2.c4471918.webp";